// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1mwgB","col":"styles_col__3TrhR"};